import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from "../../config";
import authStorage from "../../utils/authStorage";

const ConfirmIosUserTraining = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [authenticated, setAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(true);
    const [name, setName] = useState('');

    const authenticateUser = () => {

        console.log("=============")
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: `${BASE_URL}/auth/verify/signup/ios/user`, //your url
            method: 'POST',
            data: { email: params?.email, token: params?.token }
        }).then((res) => {
            setName(res?.data?.data?.name);
            setLoading(false);
            setAuthenticated(true);

            axios({
                headers: {
                    "x-access-token": params?.token,
                },
                url: `${BASE_URL}/auth/verifyToken`, //your url
                method: "GET",
            }).then((res) => {
                console.log("444444444444")
                let data = res?.data?.data;
                authStorage.setItem('walkthough', JSON.stringify({ walkThroughPending: data?.walkThroughPending, walkThroughSteps: data?.walkThroughSteps }));
                authStorage.setItem('auth-token', data?.accessToken);
                authStorage.setItem('company', data?.company ? JSON.stringify(data?.company) : "");
                authStorage.setItem('user', JSON.stringify({ price: data?.price, userCount: data.userCount, userRange: data?.userRange, expectedCftUser: data?.expectedCftUser }));
                authStorage.setItem('roles', data?.roles);
                authStorage.setItem('user-name', (data?.firstName || data?.companyName) + ' ' + (data?.lastName || ''));
                authStorage.setItem('email', data?.email);
                authStorage.setItem('subscribedStatus', data?.subscribedStatu || false);
                authStorage.setItem('planType', data?.planType || '');
                authStorage.setItem('coupon', data?.coupon || '');
                authStorage.setItem('status', data?.status || '');
                authStorage.setItem('personInCharge', data?.personInCharge || '');

                setTimeout(() => {
                    console.log("5555555555555")
                    navigate('/personalAppTraining');
                }, 200);
            });

        }).catch((err) => {
            setLoading(false);
            setError('Verification Failed Please Try Again')
        });
    };

    useEffect(() => {
        authenticateUser();
    }, []);

    return (
        <div className="bg-[#00000029] dark:bg-slate-900" style={{ height: '100vh' }}>
            <div className="flex items-center justify-center dark:border-gray-700 text-gray-600 h-[80vh]">
                <div>
                    {loading ? (
                        <div>
                            <div className="lds-facebook ml-[10px]">
                                <div></div><div></div><div></div><div></div><div></div>
                            </div>
                            <br />
                        </div>
                    ) : (
                        <></>
                    )}
                    {error && <div className="text-red-500 text-lg">{error}</div>}
                </div>
            </div>
        </div>
    )
}
export default ConfirmIosUserTraining;